import { Component, input } from '@angular/core';
import { FileManagerComponent } from '../modules/file-manager/file-manager.component';

@Component({
  selector: 'ava-file-manager-custom-element',
  template: ` <ava-file-manager [directory]="directory()" /> `,
  standalone: true,
  imports: [FileManagerComponent],
})
export class FileManagerCustomElementComponent {
  directory = input('');
}
